import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { DetalleTabProps } from "../IncidenciasDetail.type"

const emptyValue = "-"

const formatValue = (value?: string | null) => (value && value !== emptyValue ? formatTextWithCapitalize(value) : emptyValue)

const DetalleTab = ({ data }: DetalleTabProps): JSX.Element => {
    // las fechas del reporte ya llegan formateadas desde el endpoint, se muestran igual que en la tabla
    const isCerrada = Boolean(data?.fecha_cierre && data.fecha_cierre !== emptyValue)

    return (
        <>
            <p className="inc-detail__section-title">Detalle de la incidencia</p>
            <div className="inc-detail__description">
                <DescriptionDetail
                    icon={"icoInfo"}
                    label={"Estatus"}
                    value={formatValue(data?.estado_incidencia)}
                />
                <DescriptionDetail
                    icon={"calendarFill"}
                    label={"Fecha y hora de registro"}
                    value={data?.fecha_registro || emptyValue}
                />
                {isCerrada ? (
                    <DescriptionDetail
                        icon={"calendarChecked"}
                        label={"Fecha y hora de cierre"}
                        value={data?.fecha_cierre || emptyValue}
                    />
                ) : null}
                <DescriptionDetail icon={"alertFill"} label={"Urgencia"} value={formatValue(data?.urgencia)} />
                <DescriptionDetail
                    icon={"surveyFill"}
                    label={"Tipo"}
                    value={formatValue(data?.tipo_incidencia)}
                />
                <DescriptionDetail
                    icon={"location"}
                    label={"Lugar o responsable"}
                    value={formatValue(data?.lugar_responsable)}
                />
                <DescriptionDetail
                    icon={"BedFilled"}
                    label={"Habitación"}
                    value={data?.numero_habitacion || emptyValue}
                />
                {data?.matricula && data.matricula !== emptyValue ? (
                    <DescriptionDetail icon={"car"} label={"Matrícula"} value={data.matricula} />
                ) : null}
                <DescriptionDetail
                    className={"inc-detail__value--multiline"}
                    icon={"chat"}
                    label={"Descripción"}
                    value={data?.descripcion || emptyValue}
                />
            </div>
            <div className="inc-detail__line" />
            <p className="inc-detail__section-title">Responsables</p>
            <div className="inc-detail__description">
                <DescriptionDetail
                    className={"inc-detail__value--full"}
                    icon={"draft"}
                    label={"Reportó"}
                    value={data?.reporta || emptyValue}
                />
                <DescriptionDetail
                    className={"inc-detail__value--full"}
                    icon={"userFilled"}
                    label={"Cerró"}
                    value={data?.cierra || emptyValue}
                />
                {data?.comentario_cierre ? (
                    <DescriptionDetail
                        className={"inc-detail__value--multiline"}
                        icon={"checkFilled"}
                        label={"Comentario de cierre"}
                        value={data.comentario_cierre}
                    />
                ) : null}
            </div>
        </>
    )
}

export default DetalleTab
